export const featureFlagsList = {
    enableAuditLogs: 'enableAuditLogs',
    enableAuditLogsDescFilter: 'enableAuditLogsDescFilter',
    enableTenantCsvUpload: 'enableTenantCsvUpload',
    doorUnlockSchedule: 'doorUnlockSchedule',
    enableDoorUnlockSchedule5MinInterval: 'enableDoorUnlockSchedule5MinInterval',
    pmsIntegration: 'pmsIntegration',
    milestoneIntegration: 'milestoneIntegration',
    vmsIntegration: 'vmsIntegration',
    eagleEyeIntegration: 'eagleEyeIntegration',
    enableIosDevices: 'enableIosDevices',
    enableWorkspaces: 'enableWorkspaces',
    enableDcuDevices: 'enableDcuDevices',
    enableTailgateDetection: 'enableTailgateDetection',
    enableReferralsOffers: 'allowedUsersForReferralSystemAuth',
    enableReferEarnButton: 'referAndEarnButton',
    enableLiveView: 'liveView',
    enableSiteUnits: 'siteUnits',
    enableElevators: 'enableElevators',
    enableStid: 'enableStid',
    keycards: 'keycards',
    enableCardReaders: 'cardReaders',
    deviceVolume: 'deviceVolume',
    enableDoorUnlockTone: 'enableDoorUnlockTone',
    cardReaders: 'cardReaders',
    securitySettingsGSuite: 'securitySettingsGSuite',
    enablePinPrivacySettings: 'enablePinPrivacySettings',
    enableDoorAlertPrivacySettings: 'enableDoorAlertPrivacySettings',
    enableYardiIntegration: 'yardiIntegration',
    useYardiRestApi: 'use-yardi-rest-api',
    enableOktaIntegration: 'oktaIntegrations',
    securitySettings: 'securitySettings',
    enablePassSettings: 'enablePassSettings',
    enableUserActivationDeactivation: 'enableUserActivationDeactivation',
    enableCustomPin: 'enableCustomPin',
    enableIosProvisioning: 'enableIosProvisioning',
    enableRexMapping: 'enableRexMapping',
    reports: 'reports',
    enableSwiftHealth: 'enableSwiftHealth',
    enableAuthByPhone: 'enableAuthByPhone',
    enableRentGpt: 'enableRentgpt',
    enableApiSettings: 'enableApiSettings',
    enableHelpSupport: 'enableHelpSupport',
    enableBilling: 'enableBilling',
    enableBillingInvoiceTemplates: 'enableBillingInvoiceTemplates',
    enableFeedLogs: 'enableFeedLogs',
    referralDismissDays: 'referralDissmissDays',
    createReport: 'createReport',
    enablePackageScan: 'enablePackageScan',
    enableThirdPartyWiegand: 'enableThirdPartyWiegand',
    enableAlerts: 'enableAlerts',
    enableEliseAI: 'enableEliseAi',
    enableUpgradeFirmware: 'enableUpgradeFirmware',
    // Gates ONLY the "Connect your existing Stripe account" (OAuth) card on the amenity Payments
    // page. That path needs a Stripe Connect platform client id (`STRIPE_CONNECT_CLIENT_ID`) which
    // is unset in every environment today, so the backend answers every attempt with
    // `503 NOT_CONFIGURED`. The backend exposes no way to ASK whether it is set — `connect-status`
    // carries no such field, and the only probe is a POST with audit-log side effects — so this
    // flag is the switch to flip once ops provisions it. An absent flag reads as false, i.e. the
    // card renders disabled with a visible reason, which is the safe default. The durable fix is a
    // one-line backend change adding `oauth_available` to `connect.serialize_site_link`, after
    // which this flag should be deleted.
    enableAmenityStripeOauth: 'enableAmenityStripeOauth',
    enableBrivoPinSync: 'enableBrivoPinSync',
};

export default featureFlagsList;
